<script>
export default {
  name: "ZzReservationStatus1Badge",
  props: {
    statusLabel: {
      type: String,
      default: ''
    },
    statusId: {
      type: String,
      default: ''
    },
  },
  methods: {
    getBackgroundColor() {
      return this.$constant.zzReservationStatus1BgColor[this.statusId] ?? '#fff3cd'
    },
    getColor() {
      return '#000';
    },
  },
  computed: {
    display() {
      return this.statusId !== this.$constant.zz_reservation_status_1.not_set;
    }
  }
}
</script>

<template>
  <span
    v-if="display"
    class="badge"
    :style="{
      'background-color': this.getBackgroundColor(),
      'color': this.getColor(),
    }"
  >{{ statusLabel }}</span>
</template>

<style scoped lang="scss">
.badge {
  padding: 0.4em 0.5em;
}
</style>
